import {
  MASTER_SIM_LIST,
  MASTER_SIM_LIST_SUCCESS,
  MASTER_SIM_LIST_FAILURE,
  MASTER_SIM_DATA,
  MASTER_SIM_DATA_SUCCESS,
  MASTER_SIM_DATA_FAILURE,
  MASTER_SIM_COMPANIES,
  MASTER_SIM_COMPANIES_SUCCESS,
  MASTER_SIM_COMPANIES_FAILURE,
  MASTER_SIM_CREATE,
  MASTER_SIM_CREATE_SUCCESS,
  MASTER_SIM_CREATE_FAILURE,
  MASTER_SIM_UPDATE,
  MASTER_SIM_UPDATE_SUCCESS,
  MASTER_SIM_UPDATE_FAILURE,
  MASTER_SIM_DELETE,
  MASTER_SIM_DELETE_SUCCESS,
  MASTER_SIM_DELETE_FAILURE,
  MASTER_SIM_SYNC,
  MASTER_SIM_SYNC_SUCCESS,
  MASTER_SIM_SYNC_FAILURE,
  MASTER_SIM_REGISTER,
  MASTER_SIM_REGISTER_SUCCESS,
  MASTER_SIM_REGISTER_FAILURE,
  MASTER_SIM_ACTIVATE,
  MASTER_SIM_ACTIVATE_SUCCESS,
  MASTER_SIM_ACTIVATE_FAILURE,
  MASTER_SIM_SUSPEND,
  MASTER_SIM_SUSPEND_SUCCESS,
  MASTER_SIM_SUSPEND_FAILURE,
  MASTER_SIM_ASSIGN,
  MASTER_SIM_ASSIGN_SUCCESS,
  MASTER_SIM_ASSIGN_FAILURE,
  MASTER_SIM_UNASSIGN,
  MASTER_SIM_UNASSIGN_SUCCESS,
  MASTER_SIM_UNASSIGN_FAILURE,
} from "./actionType";

// MASTER_SIM_LIST
export const masterSimList = () => ({ type: MASTER_SIM_LIST });
export const masterSimListSuccess = (data) => ({
  type: MASTER_SIM_LIST_SUCCESS,
  payload: data,
});
export const masterSimListFailure = (error) => ({
  type: MASTER_SIM_LIST_FAILURE,
  payload: error,
});

// MASTER_SIM_DATA
export const masterSimData = (id) => ({ type: MASTER_SIM_DATA, payload: id });
export const masterSimDataSuccess = (data) => ({
  type: MASTER_SIM_DATA_SUCCESS,
  payload: data,
});
export const masterSimDataFailure = (error) => ({
  type: MASTER_SIM_DATA_FAILURE,
  payload: error,
});

// MASTER_SIM_COMPANIES
export const masterSimCompanies = () => ({ type: MASTER_SIM_COMPANIES });
export const masterSimCompaniesSuccess = (data) => ({
  type: MASTER_SIM_COMPANIES_SUCCESS,
  payload: data,
});
export const masterSimCompaniesFailure = (error) => ({
  type: MASTER_SIM_COMPANIES_FAILURE,
  payload: error,
});

// MASTER_SIM_CREATE
export const masterSimCreate = (data) => ({
  type: MASTER_SIM_CREATE,
  payload: data,
});
export const masterSimCreateSuccess = (data) => ({
  type: MASTER_SIM_CREATE_SUCCESS,
  payload: data,
});
export const masterSimCreateFailure = (error) => ({
  type: MASTER_SIM_CREATE_FAILURE,
  payload: error,
});

// MASTER_SIM_UPDATE
export const masterSimUpdate = (data) => ({
  type: MASTER_SIM_UPDATE,
  payload: data,
});
export const masterSimUpdateSuccess = (data) => ({
  type: MASTER_SIM_UPDATE_SUCCESS,
  payload: data,
});
export const masterSimUpdateFailure = (error) => ({
  type: MASTER_SIM_UPDATE_FAILURE,
  payload: error,
});

// MASTER_SIM_DELETE
export const masterSimDelete = (data) => ({
  type: MASTER_SIM_DELETE,
  payload: data,
});
export const masterSimDeleteSuccess = (data) => ({
  type: MASTER_SIM_DELETE_SUCCESS,
  payload: data,
});
export const masterSimDeleteFailure = (error) => ({
  type: MASTER_SIM_DELETE_FAILURE,
  payload: error,
});

// MASTER_SIM_SYNC
export const masterSimSync = () => ({ type: MASTER_SIM_SYNC });
export const masterSimSyncSuccess = (data) => ({
  type: MASTER_SIM_SYNC_SUCCESS,
  payload: data,
});
export const masterSimSyncFailure = (error) => ({
  type: MASTER_SIM_SYNC_FAILURE,
  payload: error,
});

// MASTER_SIM_REGISTER
export const masterSimRegister = (data) => ({
  type: MASTER_SIM_REGISTER,
  payload: data,
});
export const masterSimRegisterSuccess = (data) => ({
  type: MASTER_SIM_REGISTER_SUCCESS,
  payload: data,
});
export const masterSimRegisterFailure = (error) => ({
  type: MASTER_SIM_REGISTER_FAILURE,
  payload: error,
});

// MASTER_SIM_ACTIVATE
export const masterSimActivate = (data) => ({
  type: MASTER_SIM_ACTIVATE,
  payload: data,
});
export const masterSimActivateSuccess = (data) => ({
  type: MASTER_SIM_ACTIVATE_SUCCESS,
  payload: data,
});
export const masterSimActivateFailure = (error) => ({
  type: MASTER_SIM_ACTIVATE_FAILURE,
  payload: error,
});

// MASTER_SIM_SUSPEND
export const masterSimSuspend = (data) => ({
  type: MASTER_SIM_SUSPEND,
  payload: data,
});
export const masterSimSuspendSuccess = (data) => ({
  type: MASTER_SIM_SUSPEND_SUCCESS,
  payload: data,
});
export const masterSimSuspendFailure = (error) => ({
  type: MASTER_SIM_SUSPEND_FAILURE,
  payload: error,
});

// MASTER_SIM_ASSIGN
export const masterSimAssign = (data) => ({
  type: MASTER_SIM_ASSIGN,
  payload: data,
});
export const masterSimAssignSuccess = (data) => ({
  type: MASTER_SIM_ASSIGN_SUCCESS,
  payload: data,
});
export const masterSimAssignFailure = (error) => ({
  type: MASTER_SIM_ASSIGN_FAILURE,
  payload: error,
});

// MASTER_SIM_UNASSIGN
export const masterSimUnassign = (data) => ({
  type: MASTER_SIM_UNASSIGN,
  payload: data,
});
export const masterSimUnassignSuccess = (data) => ({
  type: MASTER_SIM_UNASSIGN_SUCCESS,
  payload: data,
});
export const masterSimUnassignFailure = (error) => ({
  type: MASTER_SIM_UNASSIGN_FAILURE,
  payload: error,
});
